import React from "react";
import { adds } from "../../../assets";
import Button from "../../../components/Button";
import Node from "../../../components/threejs";
import "./index.css";
import { motion } from "framer-motion";

const Hero = ({ variants }) => {
  return (
    <div className="hero flex alignCenter relative">
      <img className="blur blur1" src={adds.blur1} alt="Blur" />
      <div className="container-lg flex flexCol">
        <div className="textContainer flex flexCol">
          <motion.h5
            variants={variants}
            initial={"initial"}
            animate={"ani"}
            custom={0.3}
          >
            Potenciá tu negocio
          </motion.h5>
          <motion.h1
            variants={variants}
            initial={"initial"}
            animate={"ani"}
            custom={0.6}
          >
            Algoritmos para impactar en tu negocio
          </motion.h1>
          <motion.p
            variants={variants}
            initial={"initial"}
            animate={"ani"}
            custom={0.9}
          >
            Organiza tus datos, enriquecelos con datos externos, y realiza
            predicciones en escala con nuestros algoritmos de Inteligencia
            Artificial
          </motion.p>
          <Button
            text="Conocer más"
            color="white"
            href="/contacto"
            type={"link"}
            variants={variants}
            delay={1.2}
          />
        </div>
        <Node />
      </div>
    </div>
  );
};

export default Hero;
